import { AccountRequestCreatePage } from "@/pages/account-request-create";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth_not_requeired/register")({
  component: () => <AccountRequestCreatePage />,
});
